import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.match";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';
import generateId from '../../lib/generateId';
import sizePropTypes from '../../prop-types/Size';
import styles from './input.css';
var cx = classnames.bind(styles);

var ValidityIcon = function ValidityIcon(_ref) {
  var isValid = _ref.isValid;
  var iconClasses = cx('icon', {
    valid: isValid,
    invalid: !isValid
  });
  return React.createElement(FontAwesomeIcon, {
    className: iconClasses,
    icon: isValid ? faCheckCircle : faTimesCircle,
    size: "2x"
  });
};

ValidityIcon.propTypes = {
  isValid: PropTypes.bool
};
ValidityIcon.defaultProps = {
  isValid: undefined
};

function inputIsValid(error) {
  var isValid = arguments.length <= 1 ? undefined : arguments[1];

  if (isValid !== undefined) {
    return !error && isValid;
  }

  return !error;
}

function getInitialValue(value, mask) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return typeof value !== 'undefined' && (!mask || value.match(mask)) ? value : defaultValue;
}

function defaultState(_ref2) {
  var value = _ref2.value,
      mask = _ref2.mask,
      id = _ref2.id;
  return {
    id: id || generateId(),
    value: getInitialValue(value, mask),
    error: false,
    hadValue: !!value
  };
}

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", defaultState(_this.props));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var value = e.target.value;
      var _this$state = _this.state,
          prevValue = _this$state.value,
          hadValue = _this$state.hadValue;
      var _this$props = _this.props,
          mask = _this$props.mask,
          onChange = _this$props.onChange;
      var hasValue = value !== '';
      var violatesMask = hasValue && mask && !value.match(mask);

      if (violatesMask) {
        _this.input.value = prevValue;
      } else {
        _this.setState({
          value: value,
          hadValue: hadValue || !!value
        });

        onChange(e);
      }
    });

    return _this;
  }

  _createClass(Input, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props2 = this.props,
          id = _this$props2.id,
          value = _this$props2.value,
          mask = _this$props2.mask;
      var stateChanges = {};

      if (id !== prevState.id) {
        stateChanges.id = id;
      }

      if (value !== prevProps.value) {
        stateChanges.value = getInitialValue(value, mask, prevState.value);
      }

      if (Object.keys(stateChanges).length) {
        this.setState(stateChanges);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          bordered = _this$props3.bordered,
          caption = _this$props3.caption,
          className = _this$props3.className,
          error = _this$props3.error,
          inline = _this$props3.inline,
          isValid = _this$props3.isValid,
          label = _this$props3.label,
          mask = _this$props3.mask,
          onChange = _this$props3.onChange,
          required = _this$props3.required,
          size = _this$props3.size,
          valueProp = _this$props3.value,
          rest = _objectWithoutProperties(_this$props3, ["bordered", "caption", "className", "error", "inline", "isValid", "label", "mask", "onChange", "required", "size", "value"]);

      var _this$state2 = this.state,
          value = _this$state2.value,
          hadValue = _this$state2.hadValue,
          id = _this$state2.id;
      var empty = !value && !rest.defaultValue;
      var isIconVisible = !empty && (isValid !== undefined || required);
      var validProp = inputIsValid(required && empty && hadValue, isValid);
      var captionContent = error || caption;
      var containerClassNames = cx('inputContainer', size, {
        inline: inline,
        valid: validProp,
        invalid: !validProp,
        captionized: captionContent
      }, className);
      var inputClasses = cx({
        bordered: bordered,
        inputPlain: !label,
        inputWithLabel: label,
        filled: !empty,
        withIcon: isIconVisible
      });
      return React.createElement("div", {
        className: containerClassNames
      }, React.createElement("input", _extends({
        className: inputClasses,
        id: id,
        onChange: this.handleChange,
        ref: function ref(el) {
          _this2.input = el;
        },
        required: required,
        value: value
      }, rest)), label &&
      /* eslint-disable-next-line jsx-a11y/label-has-for */
      React.createElement("label", {
        className: cx('label'),
        htmlFor: id
      }, label), captionContent && React.createElement("span", {
        className: cx('caption', {
          error: error
        })
      }, captionContent), isIconVisible && React.createElement(ValidityIcon, {
        isValid: validProp
      }));
    }
  }]);

  return Input;
}(React.Component);

_defineProperty(Input, "propTypes", {
  /** Boolean to set box-shadow on element */
  bordered: PropTypes.bool,

  /** Text displayed underneath the input */
  caption: PropTypes.string,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Error displayed underneath the input */
  error: PropTypes.string,

  /** Id for input element  */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Boolean allowing input to be displayed inline */
  inline: PropTypes.bool,

  /** Boolean to render valid/invalid icon */
  isValid: PropTypes.bool,

  /** String value to be displayed inside the input as a label/input name */
  label: PropTypes.string,

  /** Regex to filter acceptable input values */
  mask: PropTypes.instanceOf(RegExp),

  /** Change handler */
  onChange: PropTypes.func,

  /** boolean value to indicate if input is required or not */
  required: PropTypes.bool,

  /** String that represents size of input */
  size: sizePropTypes,

  /** Initial value to set in the input */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

_defineProperty(Input, "defaultProps", {
  bordered: true,
  caption: undefined,
  className: undefined,
  error: undefined,
  id: undefined,
  inline: false,
  isValid: undefined,
  label: undefined,
  mask: undefined,
  onChange: function onChange() {},
  size: undefined,
  required: undefined,
  value: ''
});

export { Input as default };